const NEW_TAB_URLS = ['customstore'];

export { NEW_TAB_URLS };
